/**
 * Smart search helpers — token-AND, accent- and case-insensitive.
 *
 * Usage:
 *   const norm = normalizeForSearch("Camión Dell I5");  // "camion dell i5"
 *   const ok   = tokenMatch("dell i5 8va", "Dell 7400 i5 8va de oferta");
 *   const list = items.filter((it) => tokenMatch(q, it.name, it.sku, it.characteristics));
 *
 * `tokenMatch(q, ...fields)` returns true when EVERY token from `q` appears in
 * at least one of the provided field strings (after Unicode normalization).
 */
export function normalizeForSearch(s) {
  if (s == null) return "";
  return String(s)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // strip combining marks (accents)
    .toLowerCase();
}

export function tokenMatch(query, ...fields) {
  const q = (query || "").trim();
  if (!q) return true;
  const tokens = normalizeForSearch(q).split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  const haystack = fields.map(normalizeForSearch).join(" \n ");
  return tokens.every((tok) => haystack.includes(tok));
}
